export default "__VITE_ASSET__ClDz8CcW__"